var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 27.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#07586b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,13.94a7.48,7.48,0,1,0-7.55,0A13.19,13.19,0,0,0,0,26.1a1,1,0,0,0,1,1H23.27a1,1,0,0,0,1-1A13,13,0,0,0,16,13.94ZM6.81,7.48a5.43,5.43,0,1,1,5.42,5.43A5.43,5.43,0,0,1,6.81,7.48ZM2.1,25.07h0c.52-5.31,5-9.77,10.05-9.77s9.52,4.46,10,9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,12.18H27.5V8.72a1,1,0,1,0-2.07,0v3.46H22a1,1,0,1,0,0,2.07h3.46v3.46a1,1,0,1,0,2.07,0V14.25H31a1,1,0,1,0,0-2.07Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteButton);
export default __webpack_public_path__ + "static/media/InviteButton.a170e934.svg";
export { ForwardRef as ReactComponent };